
import React from "react";
import { Job } from "@/types/job";
import { Button } from "@/components/ui/button";
import { AIJobRecommendation } from "./AIJobRecommendation";

interface JobMatchingResultsProps {
  jobs: Job[];
  isPremium: boolean;
  isAnalyzing: boolean;
  savedJobs: string[];
  toggleSaveJob: (id: string | number) => void;
  isSaved: (id: string | number) => boolean;
  showActions?: boolean;
  updateFilters?: (filters: any) => void;
  onJobSelect?: (job: Job) => void;
}

export const JobMatchingResults: React.FC<JobMatchingResultsProps> = ({
  jobs,
  isPremium,
  isAnalyzing,
  savedJobs,
  toggleSaveJob,
  isSaved,
  showActions = false,
  updateFilters,
  onJobSelect
}) => {
  if (isAnalyzing) {
    return (
      <div className="space-y-6">
        {Array(3).fill(0).map((_, idx) => (
          <div key={idx} className="border border-gray-200 rounded-xl p-6 animate-pulse">
            <div className="flex gap-4 items-start">
              <div className="h-12 w-12 bg-gray-200 rounded-lg"></div>
              <div className="flex-1 space-y-3">
                <div className="h-5 bg-gray-200 rounded w-3/4"></div>
                <div className="h-4 bg-gray-200 rounded w-1/2"></div>
                <div className="grid grid-cols-2 gap-2">
                  <div className="h-3 bg-gray-200 rounded w-2/3"></div>
                  <div className="h-3 bg-gray-200 rounded w-1/2"></div>
                  <div className="h-3 bg-gray-200 rounded w-1/2"></div>
                  <div className="h-3 bg-gray-200 rounded w-2/3"></div>
                </div>
                <div className="h-4 bg-gray-200 rounded w-full"></div>
                <div className="flex gap-2">
                  <div className="h-6 bg-gray-200 rounded w-16"></div>
                  <div className="h-6 bg-gray-200 rounded w-16"></div>
                  <div className="h-6 bg-gray-200 rounded w-16"></div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    );
  }

  if (jobs.length === 0) {
    return null;
  }

  return (
    <div className="space-y-6">
      {jobs.map((job) => (
        <AIJobRecommendation
          key={job.id}
          job={job}
          isPremium={isPremium}
          isSaved={isSaved(job.id)}
          onSave={() => toggleSaveJob(job.id)}
          showActions={showActions}
          onViewDetails={() => onJobSelect && onJobSelect(job)}
        />
      ))}
      
      {jobs.length > 5 && (
        <div className="text-center py-4">
          <Button variant="outline" className="mx-auto">
            Load More Jobs
          </Button>
        </div>
      )}
    </div>
  );
};
